<div class="btn g-btn-danger cursor-pointer btn-danger" (click)="endProgress()"> Stop Process...</div>